import React from "react";
import { Icon } from "@telia/teddy";
import "./SubscriptionCard.less";

interface SubscriptionCardProps {
    name: string;
    phone: string;
}

const SubscriptionCard: React.FC<SubscriptionCardProps> = ({ name, phone }) => {
    return (
        <div className="subscription-card">
            <Icon className="subscription-card__icon" name="simcard" />
            <div className="subscription-card__details" data-di-mask>
                <div className="subscription-card__details__name">{name}</div>
                <div className="subscription-card__details__phone">{phone}</div>
            </div>
        </div>
    );
};

export default SubscriptionCard;
